import { useEffect, useState } from 'react';
import { usePlatform } from '../platform/platform-context';
/** Read existing identity without issuing a credential or opening a challenge. */
export function useDeviceFeatures() {
  const { identity } = usePlatform();
  const configured = Boolean(import.meta.env.VITE_TURNSTILE_SITE_KEY);
  const [credentialReady, setCredentialReady] = useState(false);
  useEffect(() => {
    let active = true;
    void identity
      .getDeviceCredential()
      .then((result) => {
        if (active) setCredentialReady(result.ok && result.value !== undefined);
      })
      .catch(() => {
        if (active) setCredentialReady(false);
      });
    return () => {
      active = false;
    };
  }, [identity]);
  return configured || credentialReady;
}
